import React from 'react'

export default function Experience() {
  return (
    <div className='experience flex flex-col items-center experience mb-8 font-bold text-lg'>
        <p className='mb-3.5 font-bold'>A <span className='dark-text'>Notable</span> Experience</p>
        <p className='w-2/4 text-center mb-3.5'>“ As a writer, this has vastly improved my process. No more switching between tabs to find my document, just tap on Noted and start writing ”</p>
        <p>Jason Love - Writer</p>
    </div>
  )
}